/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_Private_InquiryInputs */

const en_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Private Inquiry`)
};

const es_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar consulta privada`)
};

const fr_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre une demande privée`)
};

const de_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Anfrage senden`)
};

const ja_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートな問い合わせを送信`)
};

const zh_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交私密咨询`)
};

const ar_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال استفسار خاص`)
};

const id_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim Pertanyaan Pribadi`)
};

const it_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia Richiesta Privata`)
};

const ru_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить личный запрос`)
};

const pt_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar Consulta Privada`)
};

const ko_submit_private_inquiry = /** @type {(inputs: Submit_Private_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비공개 문의 제출`)
};

/**
* | output |
* | --- |
* | "Submit Private Inquiry" |
*
* @param {Submit_Private_InquiryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const submit_private_inquiry = /** @type {((inputs?: Submit_Private_InquiryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Private_InquiryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_submit_private_inquiry(inputs)
	if (locale === "es") return es_submit_private_inquiry(inputs)
	if (locale === "fr") return fr_submit_private_inquiry(inputs)
	if (locale === "de") return de_submit_private_inquiry(inputs)
	if (locale === "ja") return ja_submit_private_inquiry(inputs)
	if (locale === "zh") return zh_submit_private_inquiry(inputs)
	if (locale === "ar") return ar_submit_private_inquiry(inputs)
	if (locale === "id") return id_submit_private_inquiry(inputs)
	if (locale === "it") return it_submit_private_inquiry(inputs)
	if (locale === "ru") return ru_submit_private_inquiry(inputs)
	if (locale === "pt") return pt_submit_private_inquiry(inputs)
	return ko_submit_private_inquiry(inputs)
});